import React from "react";
import { PageHero, PageBody, formatDate } from "./_shared";
import { useNursing } from "./NursingLayout";
import { FileText, ExternalLink } from "lucide-react";

export default function Notices() {
  const data = useNursing();
  const notices = data.notices_general || [];
  return (
    <div data-testid="nur-notices">
      <PageHero eyebrow="Official Notices" title="What's happening on campus" />
      <PageBody>
        {notices.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center text-sm text-[#475569] ring-1 ring-[#E2E8F0]">No notices have been posted yet.</div>
        ) : (
          <div className="space-y-3">
            {notices.map((n) => (
              <a key={n.id} href={n.file_url || n.external_url || "#"} target="_blank" rel="noopener noreferrer"
                 className="block bg-white rounded-xl p-5 ring-1 ring-[#E2E8F0] hover:ring-2 hover:ring-[#0FB28A] transition-all">
                <div className="flex items-start gap-3">
                  <FileText className="text-[#0FB28A] mt-0.5" size={20} />
                  <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-wider text-[#0FB28A] font-bold">{formatDate(n.posted_on || n.notice_date)}</div>
                    <div className="text-sm mt-1 text-[#0F2A5F] font-semibold">{n.title}</div>
                    {n.body && <p className="text-[12px] text-[#475569] mt-1 leading-relaxed">{n.body}</p>}
                  </div>
                  <ExternalLink className="text-[#475569]" size={14} />
                </div>
              </a>
            ))}
          </div>
        )}
      </PageBody>
    </div>
  );
}
